import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'
import NProgress from 'nprogress'
import DatePicker from 'react-datepicker';
import moment from 'moment';
import GoogleAnalytics from 'react-ga';

import PlayButton from './PlayButton'
import ElementMenu from './ElementMenu'

import Notification from '../services/Notification.js'
import Train from '../services/train.js';
import StringUtils from '../services/StringUtils.js';
import QueryParamsUtils from '../services/QueryParamsUtils.js';
import RiverData from '../models/RiverData.js';
import Element from '../services/Element.js';

import 'react-datepicker/dist/react-datepicker.css';
import '../../css/River.css';

class River extends Component {

  constructor(props, context) {
    super(props, context);

    let queryParams = new URLSearchParams(this.props.location.search);

    let from = parseInt(queryParams.get('from'), 10);
    let to = parseInt(queryParams.get('to'), 10);


    if (!from) {
      from = new Date();
      from.setFullYear(from.getFullYear() - 1);
      from.setDate(from.getDate() + 1);
    } 

    if (!to) {
      to = new Date();
    }

    this.state = {
      menu: {active: false},
      hover: {},
      from: moment(from),
      to: moment(to),
      showRange: false
    }
    this.timeSliceWidth = 150;
    this.leftMargin = 50;
    this.minRange = 14;
    this.verticalOffset = 0;
    this.fontSize = '0.7em';
    this.dateFontSize = '0.9em';
    this.hoveredFontSize = '1.2em';

    this.headerHeight = 50;
    this.playerHeight = 60;
    this.riverHeaderHeight = 30;
    this.bottomOffset = 20;

  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillReceiveProps(newProps) {
    this.props = newProps;
  }

  getHeight() {
    let height = (document.getElementById('App').offsetHeight - this.headerHeight - this.riverHeaderHeight - this.playerHeight - this.bottomOffset)*0.98;
    return height;
  }

  fetchData() {

    GoogleAnalytics.event({
      category: 'ThemeRiver',
      action: 'loaded',
      label: this.props.location.pathname
    });

    let from = this.state.from.valueOf();
    let to = this.state.to.valueOf();

    from = Math.floor(from/1000)*1000; 
    to = Math.floor(to/1000)*1000;

    if (to <= from) {
      Notification.show('Start date must be before end date!', 'warning');
      return;
    }
    else if (to - from > 15*60*60*24*365*1000) {
      Notification.show('Dates must be within 15 years', 'warning');
      return;
    }

    Notification.show('Loading listening habits', 'info');

    NProgress.start();

    if (this.state.riverData) {
      this.setState({showRange: false});
    }

    Element.nameById(this.riverContext(), this.riverSearchTerm(), (name) => {
      this.setState({name});
    });

    Train.fetchRiverData({
      context: this.riverContext(), 
      searchTerm: this.riverSearchTerm(), 
      riverType: this.riverType(), 
      riverTypeTerm: this.riverTypeTerm(),
      from, 
      to
    })
    .then((data) => {
      let riverData = new RiverData(data);
      this.setState({riverData});
      NProgress.done();
    })
    .catch((error) => {
      Notification.show('No data found for the period', 'warning');
      NProgress.done();
    });
  }

  riverSearchTerm() {
    return decodeURIComponent(this.props.match.params.searchTerm);
  }

  riverContext() {
    return this.props.match.params.context;
  }

  riverType() {
    return this.props.match.params.riverType;
  }

  riverTypeTerm() {
    return this.props.match.params.riverTypeTerm || '';
  }

  riverName() {
    return this.state.name;
  }

  riverElement() {
    let element = {};
    element[this.riverContext()] = this.riverSearchTerm();
    return element;
  }

  hovered(stream) {
    this.setState({
      hover: {stream}
    });
  }

  unhovered() {
    this.setState({
      hover: {}
    });
  }

  riverVerticalPosition(value) { 
    let canvasHeight = this.getHeight();
    let verticalPosition = Math.round(15 + (canvasHeight - 45)*( 0.5 + value )  );
    return verticalPosition;
  };

  isSelected(stream) {
    let hoveredStream = this.state.hover.stream;

    return (hoveredStream === stream);
  }

  opacity(stream) {

    if (!this.state.hover.stream)
      return 1;

    if (this.isSelected(stream))
      return 1;
    else 
      return 0.1;

  }

  nameFontSize(stream) {

    if (!this.state.hover.stream)
      return this.fontSize;

    if (this.isSelected(stream))
      return '1.5em';
    else 
      return this.fontSize;

  }

  renderStreams() {

    let riverData = this.state.riverData;
    let monthsCount = riverData.getMonthsCount();
    let elementsNumber = riverData.getElementsNumber();

    let polygons = [...Array(monthsCount - 1).keys()].map((monthIndex) => {

      return [...Array(elementsNumber).keys()].map((elementIndex) => {

        let begin = this.riverVerticalPosition(riverData.getElementPosition(monthIndex, elementIndex, 0));
        let end = this.riverVerticalPosition(riverData.getElementPosition(monthIndex, elementIndex, 1));
        let nextBegin = this.riverVerticalPosition(riverData.getElementPosition(monthIndex + 1, elementIndex, 0));
        let nextEnd = this.riverVerticalPosition(riverData.getElementPosition(monthIndex + 1, elementIndex, 1));

        let firstPoint = (this.leftMargin + monthIndex*this.timeSliceWidth) + "," + begin;
        let secondPoint = (this.leftMargin + (monthIndex+1)*this.timeSliceWidth)  + "," + nextBegin;
        let thirdPoint = (this.leftMargin + (monthIndex+1)*this.timeSliceWidth)  + "," + nextEnd;
        let fourthPoint = (this.leftMargin + monthIndex*this.timeSliceWidth)  + "," + end;

        let elementColor = riverData.getElementColor(elementIndex);

        let color = "rgb("+elementColor.r +","+elementColor.g+","+elementColor.b+")";

        let title = <title>{riverData.getElement(elementIndex).name}</title>;

        let polygon = (
          <polygon onClick={this.showMenu.bind(this, elementIndex)} opacity={this.opacity(elementIndex)} onMouseEnter={this.hovered.bind(this, elementIndex)} onMouseLeave={this.unhovered.bind(this)} key={`${monthIndex}-${elementIndex}`} points={`${firstPoint} ${secondPoint} ${thirdPoint} ${fourthPoint}`} fill={color} stroke="white" strokeWidth="0.2">
            {title}
          </polygon>
        );

        return polygon;

      });          

    });

    return polygons.reduce((a, b) => {
      return a.concat(b);
    });

  }

  renderNames() {

    let riverData = this.state.riverData;
    let monthsCount = riverData.getMonthsCount();
    let elementsNumber = riverData.getElementsNumber();

    let names = [...Array(elementsNumber).keys()].map((elementIndex) => {

      let range = 0;
      let prevRange = 0;
      let largestMonth = 0; 
      let largestRange = 0;
      let largestBegin;
      let largestEnd;
      let monthsInARow = 0;
      let lastMonthDrawn = undefined;

      return [...Array(monthsCount).keys()].map((monthIndex) => {

        let begin = this.riverVerticalPosition(riverData.getElementPosition(monthIndex, elementIndex, 0));
        let end = this.riverVerticalPosition(riverData.getElementPosition(monthIndex, elementIndex, 1));

        prevRange = range;
        range = end - begin;
      
        if (
          range > largestRange 
          && 
          (lastMonthDrawn === undefined || (monthIndex - lastMonthDrawn) > 2 ) 
        )

        {
          largestRange = range;
          largestMonth = monthIndex;
          largestBegin = begin;
          largestEnd = end;
        }

        let text = <text key={`${monthIndex}-${elementIndex}`}></text>;

        if ( 
          ( 
            ( 
              range <= this.minRange 
              || 
              monthIndex === (monthsCount - 1) ) 
              || 
              (prevRange <= this.minRange && monthIndex === (monthsCount - 1) ) 
              || 
              (monthsInARow >= 4)
            )
            && 
            largestRange > this.minRange
            

          ) {

            let y = (largestBegin+largestEnd)/2 + this.verticalOffset;
            let x = (this.leftMargin + largestMonth*this.timeSliceWidth); 

            if (largestMonth === 0)
              x += 0;
            else if (largestMonth === monthsCount - 1)
              x -= this.timeSliceWidth/3.0;
            else
            {
              if (prevRange > range)
                x -= this.timeSliceWidth/10.0;
              else
                x += this.timeSliceWidth/10.0;
            }

            text = (<text onClick={this.showMenu.bind(this, elementIndex)} key={`${monthIndex}-${elementIndex}`} opacity={this.opacity(elementIndex)} onMouseEnter={this.hovered.bind(this, elementIndex)} onMouseLeave={this.unhovered.bind(this)} cursor="pointer" className="" fill="white" x={x} y={y} fontSize={this.nameFontSize(elementIndex)}>
              {riverData.getElement(elementIndex).name}
            </text>);

            lastMonthDrawn = largestMonth;
            largestMonth = 0;
            largestRange = 0;
            range = 0;
            prevRange = 0;
            monthsInARow = 0;

        }

        
        monthsInARow++;

        return text;
      });


    });

    return names.reduce((a, b) => {
      return a.concat(b);
    });

  }

  renderDates() {
    let riverData = this.state.riverData;
    let monthsCount = riverData.getMonthsCount();

    return [...Array(monthsCount).keys()].map((index) => {
      
      let x = this.leftMargin/4 + index*this.timeSliceWidth;
      let y = this.getHeight() - 10;
      
      return (
        <text key={index} className="not-selectable" fontSize={this.dateFontSize} fontWeight="bold" x={x} y={y} fill="white">
          {StringUtils.convertMonthString(riverData.getMonth(index))}
        </text>
      ); 

    });

  }

  showMenu(stream, evt) {
    evt.preventDefault();
    evt.stopPropagation();

    let scrollX = document.getElementById('river').scrollLeft;

    let element = this.state.riverData.getProfile(stream);

    let menuData = {
      x: evt.clientX, y: evt.clientY- 50, scrollX, active: true, artist: this.state.riverData.getElement(stream).name, artistData: element
    }

    this.setState({menu: menuData});
  }

  hideMenu() {
    this.setState({menu: {active: false}});
  }

  handleChangeStart(date) {
    this.setState({from: date});
  }

  handleChangeEnd(date) {
    this.setState({to: date});
  }

  toggleRange() {
    this.setState({showRange: !this.state.showRange});
  }

  selectPeriod() {
    let basePath = this.props.location.pathname;
    let params = {from: this.state.from.valueOf(), to: this.state.to.valueOf()};
    this.props.history.push(`${basePath}${QueryParamsUtils.toQueryParams(params)}`);
    this.fetchData();
  }

  renderRange() {

    if (!this.state.showRange)  
      return null;

    let isFuture = (date) => {
      return date < moment();
    };

    return (
      <div className="rangePicker">
        <DatePicker
          dateFormat="DD/MM/YYYY"
          selected={this.state.from}
          selectsStart
          onChange={this.handleChangeStart.bind(this)}
          todayButton={"Today"}
          showMonthDropdown
          showYearDropdown
          filterDate={isFuture}
        />

        <DatePicker
          dateFormat="DD/MM/YYYY"
          selected={this.state.to}
          selectsEnd
          endDate={this.state.to}
          onChange={this.handleChangeEnd.bind(this)}
          todayButton={"Today"}
          showMonthDropdown
          showYearDropdown
          filterDate={isFuture}
        />

        <i onClick={this.selectPeriod.bind(this)} className="clickable icon-next-step"></i>
      </div>
    );
    
  }

  render() {

    let riverData = this.state.riverData;
    let name = this.riverName();

    let elements = riverData ? riverData.getElementNames() : [];
    let playableElements = elements.map((name) => { return {artist: name}; } );

    let monthsCount = riverData ? riverData.getMonthsCount() : 0;
    
    let width = (monthsCount*this.timeSliceWidth);

    let showRiver = riverData && name && monthsCount > 0 && elements.length > 0;

    return (
      <div id="river">

        <div className="header">

          <h1><Link onMouseEnter={this.hovered.bind(this, name)} onMouseLeave={this.unhovered.bind(this, name)} className="clickable" to={Element.url(this.riverContext(), this.riverElement())}>{name}</Link></h1>
          <PlayButton type={'artist'} elements={playableElements}/>

          <i onClick={this.toggleRange.bind(this)} className={`${this.state.showRange ? 'active' : ''} clickable icon-calendar`}></i>

          {this.renderRange()}

        </div>

        {showRiver && <svg onClick={this.hideMenu.bind(this)} id="riverSvg" width={width} height={this.getHeight()} xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision">
          <g id="svgGroup">
            {this.renderStreams()}
            {this.renderDates()}
            {this.renderNames()}
          </g>
        </svg>}

        {showRiver && <ElementMenu hide={this.hideMenu.bind(this)} element={this.state.menu.artist} elementData={this.state.menu.artistData} active={this.state.menu.active} x={this.state.menu.x} y={this.state.menu.y} scrollX={this.state.menu.scrollX}/>}

      </div>
    );

  }

}

export default withRouter(River);



// WEBPACK FOOTER //
// ./src/js/components/River.jsx